'use strict'

if (typeof angular !== 'undefined') {
  // eslint-disable-next-line no-undef
  angular.module('Model', []).factory('Model', [ModelSingleton])
}

function ModelSingleton() {
  function Model(options) {
    this.params = options || {}
  }

  Model.prototype.get = function () {
    return this.params
  }

  Model.prototype.set = function (params) {
    this.params = this.extend(this.params, params)

    return this.params
  }

  Model.prototype.extend = function (defaults, options) {
    return Object.assign(defaults, options)
  }

  return Model
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = ModelSingleton
}
